
import React from 'react';
import { connect } from "react-redux"
import {AccountTypeLabel, DEVICE_WIDTH, TWO_FACTOR_AUTH} from "../../../lib/constants";
import {sprintf} from "sprintf-js";
import {InvestmentAccountType} from "../../../lib/proto/investment_accounts";
import {Info, Action, TextLoading, VimeoIcon, VIMEO_ICON_TYPE} from "../../funcs/utils";
import { is_ira_type } from "../../../lib/constants";
import {sendWireInstructions} from "../../dashboard/user/actions";
import {PaymentsContainer2} from "../PaymentsDashboard/common";

const UGMA_INFO_TEXT = "The accumulation of funds from birthdays, holidays, graduations and "
  + "general gifting can add up to a significant sum to help launch the child into adulthood. "
  + "Help to direct this funding to this account by inviting friends and family here.";

const IRA_DISTRIBUTION_TEXT = "Since gains and income grow tax free within IRAs, the IRS will want to eventually "
+ "tax the accumulation of wealth held within these accounts.  At the age of 72 the IRS dictates "
+ "that you start taking Required Minimum Distributions (RMDs) that will exhaust the value of your "
+ "IRA accounts by the time you reach 115 years of age. If you should pass before that age, your "
+ "beneficiary will inherit your IRA and in most cases they will have 10 years from the date they "
+ "acquire it to exhaust the value of the account. If you have a spouse that is more than 10 years "
+ "younger, the IRS has a less aggressive distribution requirement that allows for a higher account "
+ "value to pass to the surviving spouse.";

const UGMA_VIDEO_ID = "661221910";

const render_navigation_line = (props, text, navigation_url, info, do_medium) => {
  const component = props.component;
  const mouse_over = over => ev => {
    component.setState({
      over_greeting_ugma: over,
    })
  }

  const over = component.state.over_greeting_ugma;
  const span_args = {
    onMouseOver: mouse_over(true),
    onMouseOut: mouse_over(false),
    style: {
      color: over ? "#000" : "#333",
      background: over ? "#FFF" : "#EEE",
    }
  }

  const container_style = {
    cursor: "pointer",
  }

  if (!do_medium) {
    container_style.display = "flex";
    container_style.flexWrap = "nowrap";
    container_style.alignItems = "center";
  } else {
    container_style.marginTop = "1rem";
  }

  const on_click = () => {
    component.props.navigatePath(navigation_url, component.props.args);
  }

  return (
    <div style={container_style}>
      <div style={{flex: "1"}}/>
      <div onClick={on_click}>
        { info }
        <span {...span_args} >
            { ' ' }
          { text }
          </span>
      </div>
    </div>
  )
}

const on_send_wire_instructions = (user, component, index) => () => {

  component.setState({
    sending_wire: true,
  });

  sendWireInstructions(
    user.token,
    user.onboarding_token,
    TWO_FACTOR_AUTH ? user.username : user.id,
    index)
    .then(() => {
      component.setState({
        sending_wire: false,
      });
    })

}

const Greeting_ = props => {
  if (props.username) {
    return null;
  }
  if (!props.user.token) {
    return null;
  }
  const hrs = new Date().getHours();
  const name = props.user.name;

  let msg;
  if (hrs < 12) {
    msg = "Good morning";
  } else if (hrs < 17) {
    msg = "Good afternoon";
  } else {
    msg = "Good evening";
  }
  const do_medium = props.app.width < DEVICE_WIDTH.large;
  const do_small = props.app.width < DEVICE_WIDTH.medium;
  const text_style = {
    fontSize: do_medium ? "1rem" : "2rem",
    fontWeight: "600",
  }
  const right_text_style = {
    fontSize: "1rem",
    fontWeight: "600",
  }
  const flex_container = {
    display: do_small ? "block" : "flex",
    flexWrap: "nowrap",
    alignItems: "center"
  }
  const parse_acct = (acct) => {
    if (!acct) {
      return acct;
    }
    if (acct.startsWith("TMP-")) {
      return acct.substring(4);
    }
    return acct;
  }

  const tda = props.tda;
  const index = sprintf("%04d", props.acct_index);
  const tda_item = tda[index];
  const account_num = parse_acct(tda_item && tda_item.tda_account_number);
  const account_label = tda_item && AccountTypeLabel(tda[index].account_type);
  const account_type = tda_item && InvestmentAccountType[tda[index].account_type];
  const is_ugma = tda_item && tda_item.account_type === InvestmentAccountType.ugma_utma.id;
  const show_RMD = is_ira_type(account_type) && account_type.id !== "roth_ira";
  const component = props.component;
  const device = {
    width: component.props.app.width,
  }

  let ugma, ira;

  if (is_ugma) {
    let ugma_text, trustee_name;
    const onboarding = props.onboarding[index];
    if (onboarding && onboarding.role_1_first_name) {
      trustee_name = onboarding.role_1_first_name.toUpperCase();

    } else {
      trustee_name = "TRUSTEE";
    }
    ugma_text = sprintf(
        "INVITE FRIENDS AND FAMILY TO CONTRIBUTE TO %s's ACCOUNT", trustee_name);
    const video_div_style = {
      display: "flex",
      direction: do_medium ? "ltr" : "rtl",
      marginTop: "1rem",
      alignItems: "center",
    }
    const span_style = {
      paddingLeft: "0.5rem",
    }
    ugma = (
      <div>
        { render_navigation_line(
          props,
          ugma_text,
          component.getUserRoot() + "/ugma_invite",
          (<Info
            component={component}
            state={component.state}
            id={"ugma_invite"}
            popup_style={{width: "30rem"}}
            text={UGMA_INFO_TEXT}/>),
          do_medium) }
        <div style={video_div_style}>
          <span style={span_style}>Learn more about UGMAs</span>
          <VimeoIcon
            state={component.state}
            component={component}
            icon={VIMEO_ICON_TYPE.PRIMER}
            video_id={UGMA_VIDEO_ID}
            id={"ugma_video"}
          />
        </div>
      </div>
    );
  }

  if (show_RMD) {
    ira = render_navigation_line(
      props,
      "REQUIRED MINIMUM DISTRIBUTION ASSUMPTIONS",
      props.component.getUserRoot() + "/retirement_distribution",
      (<Info
        component={props.component}
        state={props.component.state}
        id={"ira_distribution"}
        popup_style={{width: "30rem", right: "0"}}
        text={IRA_DISTRIBUTION_TEXT}/>),
      do_medium);
  }

  let wire_instructions;
  const email_sent = component.state.email_sent;

  if (props.path === "/user/payments") {
    wire_instructions = (<div>
      <Action onClick={on_send_wire_instructions(props.user, component, props.acct_index)}>
        <TextLoading
          label={"Email me wire instructions"}
          loading={component.state.sending_wire}
          />
      </Action>
      { email_sent && <div align={"center"} style={{paddingTop: "0.2rem"}}>
        Sent
      </div> }
    </div>)
  }

  return (
    <PaymentsContainer2
      client={component.props.client}
      device={device}>
      { /* <div style={divStyle} id={"user-dashboard-greeting"}> */ }
      <div>
        <div style={flex_container}>
          <div>
            <div className="title_" style={text_style}>
              <span>{msg}{ ' ' }{name}</span>
            </div>
          </div>
          <div style={{flex: "1"}}/>
          { !do_small && wire_instructions }
          <div style={{flex: "1"}}/>
          <div style={right_text_style}>
            <span>{account_num} - {account_label}</span>
          </div>
          <div style={{ marginTop: "1rem"}}>
            { do_small && wire_instructions }
          </div>
        </div>
        { ugma }
        { ira }
      </div>
      {  /* </div> */ }
    </PaymentsContainer2>
  )

}

const mapStateToProps = state => {
  return {
    app: state.app,
    user: state.user,
    tda: state.tda,
    onboarding: state.onboarding,
  }
}

const Greeting = connect(mapStateToProps)(Greeting_);

export { Greeting };
